import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

function WomanWatchingSunset({...props}) {
    const {
      className,
      imageUrl,
      children,
      style
    } = props;
    const data = useStaticQuery(
      graphql`
        query {
          desktop: file(relativePath: { eq: "woman-watching-sunset.jpg" }) {
            childImageSharp {
              fluid(quality: 80, maxWidth: 1280) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `
    );

    // Set ImageData.
    const imageData = data.desktop.childImageSharp.fluid;

    return (
      <BackgroundImage 
      Tag="section"
      role="img"
      aria-label="A woman sitting on the hood of a car, gazing into the distance, watching a colorful sunset above the clouds."
      className={className}
      fluid={imageData}
      style={style}
      >
        {children}
      </BackgroundImage>
    )
  }

const styles = {
  width: "100%",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
}

export default withStyles(styles)(WomanWatchingSunset)